module.exports = __webpack_public_path__ + "e493228b5120992296ce28ea10ce8c84.svg";